import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterPagoPremio from 'views/cash/payPrizesLoyalty/filterPagoPremio'; // Importing FilterPagoPremio component
import PagoPremio from 'views/cash/payPrizesLoyalty/PagoPremio'; // Importing PagoPremio component

/**
 * Class representing the payment prize view.
 * @extends JetView
 */
export default class pagoPremioView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for navigation
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // CSS class for back button
                            view: 'button', // Button view
                            type: 'icon', // Icon type button
                            icon: 'wxi-angle-left', // Back icon
                            id: 'back-button', // ID for back button
                            align: 'center', // Center alignment
                            click: () => {
                                // Click event handler for back button
                                $$('FilterPagoPremio').show(); // Show FilterPagoPremio component
                                $$('FilterPagoPremio').clear(); // Clear FilterPagoPremio data
                                $$('FilterPagoPremio').clearValidation(); // Clear validation for FilterPagoPremio
                                $$('formPagoPremio').hide(); // Hide formPagoPremio component
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Pago Premio Lealtad') }, // Label for the view
                        {
                            type: 'wide', // Wide type for the close button
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon view for close button
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                FilterPagoPremio, // Including FilterPagoPremio component
                PagoPremio, // Including PagoPremio component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique ID for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Vertical scrolling enabled
            rows: [
                {
                    responsive: 'a5', // Responsive layout for the form
                    type: 'wide', // Wide type for the column
                    cols: [left], // Left column containing the toolbar and components
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        $$('back-button').hide(); // Initially hide the back button
    }
}

// FILE DOCUMENTED
